/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import classnames from 'classnames';

import { ISubcategoryTilesData } from './subcategory-tiles.data';
import { ISubcategoryTilesProps } from './subcategory-tiles.props.autogenerated';

import { clsHelper } from '../../utilities/class-name-helper';
import { promiseAllN } from '../../utilities/parallel-promises';
import { sendRequest } from '@msdyn365-commerce/core';

export interface ISubcategoryTilesViewProps extends ISubcategoryTilesProps<ISubcategoryTilesData> { }

//==============================================================================
// CLASS NAME UTILITY
//==============================================================================
const BASE_CLASS = 'subcategory-tiles';
const cls = (fragment?: string) => clsHelper(BASE_CLASS, fragment);

/**
 *
 * SubcategoryTiles component
 * @extends {React.PureComponent<ISubcategoryTilesProps<ISubcategoryTilesData>>}
 */
interface IState {
    subCategoryTiles: JSX.Element[];
}
class SubcategoryTiles extends React.PureComponent<ISubcategoryTilesProps<ISubcategoryTilesData>, IState> {

    public state: IState = {
        subCategoryTiles: [],
    };

    public componentDidMount(): void {
        this.findSubCategory();
    }
    public render(): JSX.Element | null {

        return (
            <div
                className={BASE_CLASS}>
                {!!this.state.subCategoryTiles.length && this.state.subCategoryTiles}
            </div>

        );
    }
    public findSubCategory() {
        const subCategoryTiles: JSX.Element[] = [];

        if (this.props.data.category.result?.Children) {

            const imageRequesters: (() => Promise<unknown>)[] = [];
            const validImages: string[] = [];
            this.props.data.category.result?.Children.forEach(curCategory => {
                const curImage = curCategory.Images?.length ? curCategory.Images[0].Uri : this.props.config.categoryImage?.src;
                const imageURL = `${this.props.context.request.apiSettings.baseImageUrl}${curImage}`;
                imageRequesters.push(() => sendRequest(imageURL || '', 'get'));
            });
            promiseAllN(imageRequesters, 20).then(result => {
                result.forEach((imageRequest: any, index: number) => {
                    if (imageRequest?.status === 200) {
                        validImages.push(imageRequest?.config?.url);
                    }
                });
                this.props.data.category.result?.Children.forEach(curCategory => {
                    let finalImageURL;
                    const curImage = curCategory.Images?.length ? curCategory.Images[0].Uri : this.props.config.categoryImage?.src;
                    const imageURL = `${this.props.context.request.apiSettings.baseImageUrl}${curImage}`;
                    if (validImages.find(url => {
                        return url === imageURL;
                    })) {
                        finalImageURL = imageURL;
                    }
                    else {
                        finalImageURL = '';
                    }

                    const hLink = curCategory.Url;
                    subCategoryTiles.push(
                        <div className={cls('tile')}>
                            <a href={hLink} className={cls('tile-link')}>
                                {finalImageURL ? (
                                    <img src={finalImageURL} className={cls('tile-image')} />
                                ) : (
                                    <div className={classnames(cls('tile-image'), 'empty')} />
                                )}
                                <span className={cls('tile-name')}>{curCategory.Name}</span>
                            </a>
                        </div>
                    );
                });

                this.setState({subCategoryTiles: subCategoryTiles});
            });
        }

    }
}

export default SubcategoryTiles;
